import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { MappedZones_MapAndZoneService } from 'src/app/core/services/utelize/system/mapping/mapped-zones-map-and-zone-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TariffsUsageService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-service';
import { TariffsUsageZonesService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-zones-service';
import { TariffUsageZoneDTO } from 'src/app/core/models/system/tariff/tariff-usage-zone.dto';
import { TypesDataWeightService } from 'src/app/core/services/utelize/system/type/types-data-weight-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-tariffs-usage-zone-modal-form',
  templateUrl: './tariffs-usage-zone-modal-form.component.html',
  styleUrls: ['./tariffs-usage-zone-modal-form.component.scss']
})

export class TariffsUsageZoneModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() thisFormCancelled: EventEmitter<void>  =new EventEmitter<void>();
  @Output() thisFormSaved    : EventEmitter<number>=new EventEmitter<number>();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                       
  private dataChargeWeightIdData!: IdAndDescriptionDTO[];
  private initialStatus          : string="Please complete the following details";
  private mappedZoneIdData!      : IdAndDescriptionDTO[];
  private newUsageTariffZone     : boolean=false;
  private thisModalFormRef!      : NgbModalRef;
  private usageTariffIdData!     : IdAndDescriptionDTO[];
  private usageTariffZone        : TariffUsageZoneDTO | undefined;
  private usageTariffZoneId      : number | undefined;
  
  public alertColourProgress    : string=AlertClassColour.Grey;
  public curUser                : SystemUserDTO;
  public endDate                : OurDate | undefined;
  public formTitle              : string="Usage Tariff Zone";
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public startDate              : OurDate | undefined=populateOurDate(this.exceptionsService,Date.now());
  public thisForm!              : UntypedFormGroup;
  public thisFormSubmitted      : boolean=false;
  
  constructor(
    private authenticationService        : AuthenticationService,
    private configSystemService          : ConfigSystemService,
    private exceptionsService            : ExceptionsService,
    private formBuilder                  : UntypedFormBuilder,
    private lastPassKillerService        : LastPassKillerService,
    private mappedZones_MapAndZoneService: MappedZones_MapAndZoneService,
    private modalService                 : NgbModal,
    private tariffsUsageService          : TariffsUsageService,
    private tariffsUsageZonesService     : TariffsUsageZonesService,
    private typesDataWeightService       : TypesDataWeightService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress=AlertClassColour.Grey;
      this.endDate            =undefined;
      this.newUsageTariffZone =false;
      this.progressInformation=this.initialStatus;
      this.startDate          =populateOurDate(this.exceptionsService, Date.now());
      this.thisFormSubmitted  =false;
      this.usageTariffZone    =undefined;
      this.usageTariffZoneId  =undefined;

      this.refreshDataChargeWeightData();
      this.refreshMappedZoneData();
      this.refreshUsageTariffData();
      this.resetProgressInformation();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetProgressInformation() {
    try {
      this.alertColourProgress    =AlertClassColour.Grey;
      this.progressInformation    =this.initialStatus;
      this.progressInformationShow=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(usageTariffZoneId: number | undefined): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.enableDisableControls(false);

      if (usageTariffZoneId != undefined && <number>usageTariffZoneId>0) {
        this.usageTariffZoneId=usageTariffZoneId;

        this.getUsageTariffZoneAndOpenModal();

      } else {
        this.newUsageTariffZone=true;

        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getUsageTariffZoneAndOpenModal() {
    try {
      this.tariffsUsageZonesService.getById(<number>this.usageTariffZoneId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.usageTariffZone=data;
           
          this.populateFormFields(this.thisForm);
          this.openModal();
         },
        error: error => {
          this.thisFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.addFormControl(formGroup, "active",             true,      []);
        this.addFormControl(formGroup, "dataChargePerX",     undefined, [Validators.required]);
        this.addFormControl(formGroup, "dataChargePerXEur",  undefined, [Validators.required]);
        this.addFormControl(formGroup, "dataChargePerXUsd",  undefined, [Validators.required]);
        this.addFormControl(formGroup, "dataChargeWeightId", undefined, [Validators.required]);
        this.addFormControl(formGroup, "endDate",            undefined, []);
        this.addFormControl(formGroup, "mappedZoneId",       undefined, [Validators.required]);
        this.addFormControl(formGroup, "startDate",          undefined, [Validators.required]);
        this.addFormControl(formGroup, "usageTariffId",      undefined, [Validators.required]);
        this.addFormControl(formGroup, "uplift",             false,     []);

        this.thisForm.controls["startDate"].setValue(this.startDate?.date);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm && this.usageTariffZone) {
        this.thisForm.controls["active"].setValue(this.usageTariffZone.active);
        this.thisForm.controls["dataChargePerX"].setValue(this.usageTariffZone.dataChargePerX);
        this.thisForm.controls["dataChargePerXEur"].setValue(this.usageTariffZone.dataChargePerXEur);
        this.thisForm.controls["dataChargePerXUsd"].setValue(this.usageTariffZone.dataChargePerXUsd);
        this.thisForm.controls["dataChargeWeightId"].setValue(this.usageTariffZone.dataChargeWeightID);
        this.thisForm.controls["endDate"].setValue(this.usageTariffZone.endDate);
        this.thisForm.controls["mappedZoneId"].setValue(this.usageTariffZone.mappedZoneID);
        this.thisForm.controls["startDate"].setValue(this.usageTariffZone.startDate);
        this.thisForm.controls["usageTariffId"].setValue(this.usageTariffZone.usageTariffID);
        this.thisForm.controls["uplift"].setValue(this.usageTariffZone.uplift);

        this.startDate=populateOurDate(this.exceptionsService, this.usageTariffZone.startDate);

        if (this.usageTariffZone.endDate)
          this.endDate=populateOurDate(this.exceptionsService, this.usageTariffZone.endDate);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;

      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      this.prepareToSaveUsageTariffZone();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="dataChargeWeightId") {
        return this.dataChargeWeightIdData;

      } else if (fieldName=="mappedZoneId") {
        return this.mappedZoneIdData;
        
      } else if (fieldName=="usageTariffId") {
        return this.usageTariffIdData;

      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="dataChargeWeightId") {
              this.dataChargeWeightIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="mappedZoneId") {
              this.mappedZoneIdData=(data as IdAndDescriptionDTO[]);
              
            } else if (fieldName=="usageTariffId") {
              this.usageTariffIdData=(data as IdAndDescriptionDTO[]);

            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshDataChargeWeightData() {
    try {
      this.getDropdownData(this.typesDataWeightService.getIdAndDescription(), "dataChargeWeightId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshMappedZoneData() {
    try {
      this.getDropdownData(this.mappedZones_MapAndZoneService.getIdAndDescription(), "mappedZoneId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshUsageTariffData() {
    try {
      this.getDropdownData(this.tariffsUsageService.getIdAndDescription(), "usageTariffId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion

  public startDateChanged(startDate: OurDate) {
    try {
      this.startDate=startDate;

      this.thisForm.controls["startDate"].setValue(this.startDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public endDateChanged(endDate: OurDate) {
    try {
      this.endDate=endDate;

      this.thisForm.controls["endDate"].setValue(this.endDate.date);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private prepareToSaveUsageTariffZone() {
    try
    {
      this.resetProgressInformation();
        
      let usageTariffZone: TariffUsageZoneDTO={
        active            : this.thisForm.controls["active"].value,
        dataChargePerX    : this.thisForm.controls["dataChargePerX"].value,
        dataChargePerXEur : this.thisForm.controls["dataChargePerXEur"].value,
        dataChargePerXUsd : this.thisForm.controls["dataChargePerXUsd"].value,
        dataChargeWeightID: this.thisForm.controls["dataChargeWeightId"].value,
        endDate           : this.thisForm.controls["endDate"].value,
        enteredBy         : this.curUser.userId,
        id                : this.usageTariffZoneId ?? -1,
        mappedZoneID      : this.thisForm.controls["mappedZoneId"].value,
        startDate         : this.thisForm.controls["startDate"].value,
        uplift            : this.thisForm.controls["uplift"].value,
        usageTariffID     : this.thisForm.controls["usageTariffId"].value
      };
                  
      this.saveUsageTariffZone(usageTariffZone)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.processComplete();
                  
          if (this.newUsageTariffZone) {
            this.usageTariffZoneId=data["id"];
          }
          
          this.thisFormSaved.emit(this.usageTariffZoneId);
        },
        error: error => {
          this.alertColourProgress    =AlertClassColour.Red;
          this.progressInformation    =`Process cannot continue - ${error.message}`;
          this.progressInformationShow=true;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  private saveUsageTariffZone(usageTariffZone: TariffUsageZoneDTO): Observable<TariffUsageZoneDTO> {
    return this.tariffsUsageZonesService.save(usageTariffZone);
  }

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newUsageTariffZone ? "Usage Tariff Zone Created" : "Usage Tariff Zone Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalFormClosed() {
    try {
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
